export default "__VITE_ASSET__D0FxHb10__"